(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-vertical-tabs"] && !Shopify.designMode) return;
  try {
    


document.addEventListener('DOMContentLoaded', function () {

  // Support multiple instances of the section safely
  document.querySelectorAll('.homepage_tabbed-carousel').forEach((root) => {

    const isMobile = window.innerWidth <= 768;

    const tabsUl = root.querySelector('.homepage_tabbed_tabs');
    if (!tabsUl) return;

    // IMPORTANT: use ONLY tabs inside this section instance
    let tabs = Array.from(tabsUl.querySelectorAll('li'));

    const images = root.querySelectorAll('.main-image-block');
    const carousels = root.querySelectorAll('.carousel-wrapper');

    let activeIndex = tabs.findIndex(tab => tab.classList.contains('active'));
if (activeIndex === -1) activeIndex = 0;



    function syncContent(index) {
      images.forEach(img => img.classList.remove('active'));
      carousels.forEach(c => c.classList.remove('active'));

      const img = root.querySelector(`.main-image-block[data-index="${index}"]`);
      const carousel = root.querySelector(`.carousel-wrapper[data-index="${index}"]`);

      if (img) img.classList.add('active');

      if (carousel) {
        carousel.classList.add('active');

        // Resize Flickity ONLY if it exists
        const flktyElement = carousel.querySelector('.flickity-carousel');
        if (flktyElement && flktyElement.flickityInstance) {
          flktyElement.flickityInstance.resize();
        }
      }
    }

    /* =========================================================
       Flickity init (GUARDED so mobile never crashes)
       ========================================================= */
    if (window.Flickity) {
      root.querySelectorAll('.flickity-carousel').forEach((el) => {
        // Prevent double-init
        if (el.flickityInstance) return;

        const flkty = new Flickity(el, {
          wrapAround: true,
          prevNextButtons: true,
          pageDots: false,
          cellAlign: 'left',
          contain: true
        });

        el.flickityInstance = flkty;
      });
    }

    /* =========================================================
       MOBILE — Infinite scroll tabs + click works (REAL MOBILE FIX)
       - Works whether UL itself scrolls OR a parent wrapper scrolls
       - Clicking a clone keeps THAT clicked element centered and shows correct data
       ========================================================= */
    if (isMobile) {

      // Find the ACTUAL horizontal scroller (UL or a parent with overflow-x)
      function findHorizontalScroller(el) {
        // If UL scrolls, use it
        if (el.scrollWidth > el.clientWidth + 1) return el;

        // Otherwise walk up to find a parent that scrolls horizontally
        let p = el.parentElement;
        while (p && p !== root) {
          if (p.scrollWidth > p.clientWidth + 1) return p;
          p = p.parentElement;
        }

        // Fallback to UL
        return el;
      }

      const scroller = findHorizontalScroller(tabsUl);

      const realCount = tabs.length;
      let isAutoScrolling = false;
      let autoScrollTimer = null;

      // Clone once per instance (INTO THE UL, not the scroller)
      if (!tabsUl.dataset.infiniteReady) {

        const before = tabs.map((t) => {
          const clone = t.cloneNode(true);
          const idx = t.getAttribute('data-index');
          if (idx !== null) clone.setAttribute('data-index', idx);
          return clone;
        });

        const after = tabs.map((t) => {
          const clone = t.cloneNode(true);
          const idx = t.getAttribute('data-index');
          if (idx !== null) clone.setAttribute('data-index', idx);
          return clone;
        });

        before.reverse().forEach(el => tabsUl.prepend(el));
        after.forEach(el => tabsUl.appendChild(el));

        tabsUl.dataset.infiniteReady = "true";
      }

      // Re-read tabs AFTER cloning
      const allTabs = Array.from(tabsUl.querySelectorAll('li'));

      // Robust center calculations (mobile-safe)
      function tabCenterInScrollCoords(tabEl) {
        const tabRect = tabEl.getBoundingClientRect();
        const scRect = scroller.getBoundingClientRect();
        const leftInsideScroller = (tabRect.left - scRect.left) + scroller.scrollLeft;
        return leftInsideScroller + tabRect.width / 2;
      }

      function scrollerCenterInScrollCoords() {
        return scroller.scrollLeft + scroller.clientWidth / 2;
      }

      function getClosestTabGlobal() {
        const center = scrollerCenterInScrollCoords();

        let closestTab = null;
        let closestListIndex = 0;
        let minDist = Infinity;

        allTabs.forEach((tab, i) => {
          const c = tabCenterInScrollCoords(tab);
          const dist = Math.abs(center - c);
          if (dist < minDist) {
            minDist = dist;
            closestTab = tab;
            closestListIndex = i;
          }
        });

        const dataIndex = closestTab ? Number(closestTab.getAttribute('data-index')) : 0;
        return { tab: closestTab, listIndex: closestListIndex, dataIndex };
      }

      function updateActiveClass(explicitTabEl) {
        allTabs.forEach(t => t.classList.remove("active"));
        if (explicitTabEl) explicitTabEl.classList.add("active");
      }

      function updateMobileScale() {
        const center = scrollerCenterInScrollCoords();

        allTabs.forEach(tab => {
          const tabCenter = tabCenterInScrollCoords(tab);
          const dist = Math.abs(center - tabCenter);

          let fontSize = 8;
          let opacity = 0.3;

          if (dist < 40) { fontSize = 30; opacity = 1; }
          else if (dist < 80) { fontSize = 18; opacity = 0.9; }
          else if (dist < 120) { fontSize = 18; opacity = 0.7; }
          else if (dist < 160) { fontSize = 18; opacity = 0.7; }

          tab.style.fontSize = fontSize + "px";
          tab.style.opacity = opacity;
        });
      }

      function centerElement(el, smooth = false) {
        if (!el) return;

        isAutoScrolling = true;

        const targetLeft = tabCenterInScrollCoords(el) - scroller.clientWidth / 2;

        scroller.scrollTo({
          left: targetLeft,
          behavior: smooth ? "smooth" : "auto"
        });

        clearTimeout(autoScrollTimer);
        autoScrollTimer = setTimeout(() => {
          isAutoScrolling = false;

          // Normalize invisibly into the middle set
          // Compute set width by comparing centers of the same item across sets
          const middle0 = allTabs[realCount]; // first item of middle set
          const left0 = allTabs[0];           // first item of left set

          const setShift = (middle0 && left0)
            ? (tabCenterInScrollCoords(middle0) - tabCenterInScrollCoords(left0))
            : 0;

          const closest = getClosestTabGlobal();

          if (setShift) {
            if (closest.listIndex < realCount) {
              scroller.scrollLeft += setShift;        // left clones -> middle
            } else if (closest.listIndex >= realCount * 2) {
              scroller.scrollLeft -= setShift;        // right clones -> middle
            }
          }

          const closestAfter = getClosestTabGlobal();
          activeIndex = closestAfter.dataIndex;

          updateActiveClass(closestAfter.tab);
          updateMobileScale();
          syncContent(activeIndex);

        }, 520); // allow real mobile inertia
      }

      scroller.addEventListener("scroll", () => {
        updateMobileScale();
        if (isAutoScrolling) return;

        const closest = getClosestTabGlobal();

        if (closest.dataIndex !== activeIndex) {
          activeIndex = closest.dataIndex;
          syncContent(activeIndex);
        }

        updateActiveClass(closest.tab);
      }, { passive: true });

      // CLICK/TAP: bind on UL but use scroller for centering
      function handleTabActivate(li) {
        const idxAttr = li.getAttribute("data-index");
        const index = Number(idxAttr);
        if (Number.isNaN(index)) return;

        activeIndex = index;

        // Show correct content immediately
        syncContent(activeIndex);

        // Immediately mark clicked LI active (even if clone)
        updateActiveClass(li);

        // Keep THAT clicked LI centered
        centerElement(li, true);
      }

      // Better on mobile than click-only (still keeps click for compatibility)
      tabsUl.addEventListener("pointerup", (e) => {
        const li = e.target.closest("li");
        if (!li || !tabsUl.contains(li)) return;
        handleTabActivate(li);
      });

      tabsUl.addEventListener("click", (e) => {
        const li = e.target.closest("li");
        if (!li || !tabsUl.contains(li)) return;
        handleTabActivate(li);
      });

      // Initial: center middle copy of activeIndex
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const initial = allTabs[realCount + activeIndex] || allTabs[0];
          syncContent(activeIndex);
          updateActiveClass(initial);
          updateMobileScale();
          centerElement(initial, false);
        });
      });

      return; // stop desktop logic
    }

    /* =========================================================
       DESKTOP (unchanged behavior)
       ========================================================= */
    function updatePositions() {
      const spacingMapDesktop = {0:0,1:45,2:81,3:113,4:142};
      const centerY = tabsUl.offsetHeight / 2;

      tabs = Array.from(tabsUl.querySelectorAll('li')); // safe refresh

      tabs.forEach((tab, i) => {
        let offset = (i - activeIndex + tabs.length) % tabs.length;
        if (offset > tabs.length / 2) offset -= tabs.length;

        let fontSize, opacity;

        if (offset === 0) { fontSize = 40; opacity = 1; }
        else if (Math.abs(offset) === 1) { fontSize = 22; opacity = 0.9; }
        else if (Math.abs(offset) === 2) { fontSize = 14; opacity = 0.7; }
        else if (Math.abs(offset) === 3) { fontSize = 12; opacity = 0.5; }
        else if (Math.abs(offset) === 4) { fontSize = 8; opacity = 0.3; }
        else { fontSize = 10; opacity = 0.2; }

        const y = centerY + (offset < 0
          ? -spacingMapDesktop[Math.abs(offset)]
          :  spacingMapDesktop[Math.abs(offset)]);

        tab.style.top = `${y}px`;
        tab.style.position = 'absolute';
        tab.style.fontSize = `${fontSize}px`;
        tab.style.opacity = opacity;
        tab.classList.toggle('active', offset === 0);
      });
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        activeIndex = i;
        updatePositions();
        syncContent(i);
      });
    });

    updatePositions();
    syncContent(activeIndex);

  });

});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const sectionRoot = document.querySelector(".hueb-interactive-tabs");
  if (!sectionRoot) return;

  const slides = sectionRoot.querySelectorAll(".stack-image");
  const container = sectionRoot.querySelector(".stack-container");
  let currentIndex = slides.length - 1;
  let swipedStack = [];
  let swipeZ = 90;
  let interval = null;
  let paused = false;

  function updateClasses() {
    slides.forEach(slide => slide.classList.remove("active", "image1", "image2", "image3"));
    if (currentIndex >= 0) {
      slides[currentIndex].classList.add("active");
      if (currentIndex - 1 >= 0) slides[currentIndex - 1].classList.add("image2");
      if (currentIndex - 2 >= 0) slides[currentIndex - 2].classList.add("image1");
      if (currentIndex - 3 >= 0) slides[currentIndex - 3].classList.add("image3");
    }
  }

  function tick() {
    if (currentIndex <= 0) {
      clearInterval(interval);
      interval = null;
      setTimeout(reverseSwipes, 300);
      return;
    }
    const current = slides[currentIndex];
    swipedStack.push(current);
    current.classList.remove("active", "image1", "image2", "image3");
    current.classList.add("swiped");
    current.style.zIndex = swipeZ++;
    currentIndex--;
    setTimeout(updateClasses, 150);
  }

  function startInterval() {
    if (interval) clearInterval(interval);
    interval = setInterval(tick, 2800);
  }

  function startForwardSwipe() {
    currentIndex = slides.length - 1;
    swipedStack = [];
    swipeZ = 90;
    updateClasses();
    if (!paused) startInterval();
  }

  function reverseSwipes() {
    if (swipedStack.length === 0) return;
    swipedStack.forEach(el => {
      el.classList.remove("swiped");
      el.classList.add("reverse");
      el.style.zIndex = 103;
    });

    setTimeout(() => {
      swipedStack.forEach(el => el.classList.remove("reverse"));
      currentIndex = slides.length - 1;
      swipedStack = [];
      updateClasses();
      setTimeout(startForwardSwipe, 500);
    }, 300);
  }

  if (container) {
    container.addEventListener("mouseenter", () => {
      paused = true;
      if (interval) { clearInterval(interval); interval = null; }
    });
    container.addEventListener("mouseleave", () => {
      paused = false;
      if (currentIndex > 0) startInterval();
    });
  }

  startForwardSwipe();

  // What's New slider
  const wnSlider = sectionRoot.querySelector('.whats-new-slider');
  if (wnSlider) {
    const wnSlides = wnSlider.querySelectorAll('.whats-new-slide');
    const wnPrev = wnSlider.querySelector('.whats-new-arrow--prev');
    const wnNext = wnSlider.querySelector('.whats-new-arrow--next');

    if (wnSlides.length <= 1) {
      if (wnPrev) wnPrev.style.display = 'none';
      if (wnNext) wnNext.style.display = 'none';
    } else {
      let wnIndex = 0;
      let wnTimer;

      function wnGoTo(n, dir) {
        wnSlides[wnIndex].classList.remove('active', 'slide-enter-right', 'slide-enter-left');
        wnIndex = (n + wnSlides.length) % wnSlides.length;
        const next = wnSlides[wnIndex];
        next.classList.add('active');
        void next.offsetWidth;
        next.classList.add(dir === 'left' ? 'slide-enter-left' : 'slide-enter-right');
      }

      function wnStart() {
        wnTimer = setInterval(() => wnGoTo(wnIndex + 1, 'right'), 3000);
      }

      function wnStop() {
        clearInterval(wnTimer);
      }

      if (wnPrev) wnPrev.addEventListener('click', () => { wnStop(); wnGoTo(wnIndex - 1, 'left'); wnStart(); });
      if (wnNext) wnNext.addEventListener('click', () => { wnStop(); wnGoTo(wnIndex + 1, 'right'); wnStart(); });

      wnSlider.addEventListener('mouseenter', wnStop);
      wnSlider.addEventListener('mouseleave', wnStart);

      wnStart();
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotlight-stacked"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".stack-image");
  let currentIndex = slides.length - 1;
  let swipedStack = [];
  let swipeZ = 90;

  function updateClasses() {
    slides.forEach(slide => slide.classList.remove("active", "image1", "image2", "image3"));
    if (currentIndex >= 0) {
      slides[currentIndex].classList.add("active");
      if (currentIndex - 1 >= 0) slides[currentIndex - 1].classList.add("image2");
      if (currentIndex - 2 >= 0) slides[currentIndex - 2].classList.add("image1");
      if (currentIndex - 3 >= 0) slides[currentIndex - 3].classList.add("image3");
    }
  }

  function startForwardSwipe() {
    currentIndex = slides.length - 1;
    swipedStack = [];
    swipeZ = 90;
    updateClasses();

    let interval = setInterval(() => {
      if (currentIndex <= 0) {
        clearInterval(interval);
        setTimeout(reverseSwipes, 600);
        return;
      }
      const current = slides[currentIndex];
      swipedStack.push(current);
      current.classList.remove("active", "image1", "image2", "image3");
      current.classList.add("swiped");
      current.style.zIndex = swipeZ++;
      currentIndex--;
      setTimeout(updateClasses, 150);
    }, 900);
  }

  function reverseSwipes() {
    if (swipedStack.length === 0) return;
    swipedStack.forEach(el => {
      el.classList.remove("swiped");
      el.classList.add("reverse");
      el.style.zIndex = 103;
    });

    setTimeout(() => {
      swipedStack.forEach(el => el.classList.remove("reverse"));
      currentIndex = slides.length - 1;
      swipedStack = [];
      updateClasses();
      setTimeout(startForwardSwipe, 500);
    }, 500);
  }

  startForwardSwipe();
});

  } catch(e) { console.error(e); }
})();
})();
